import { PropsWithChildren, useState } from 'react';

import { ArrowLeft } from '@/shared/assets';
import { ICurrencyAccount } from '@/shared/lib';
import { DashboardDialog } from '@/shared/ui';

import { AddMoneyRequisites } from './add-money-flow/add-money-requisites';

interface AddMoneyFlowModalProps extends PropsWithChildren {
  account?: ICurrencyAccount;
}

export const AddMoneyFlowModal = ({
  children,
  account,
}: AddMoneyFlowModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DashboardDialog
      titleProps={{ variant: 'm' }}
      triggerProps={{
        asChild: true,
        onClick: () => {
          setIsOpen(true);
        },
      }}
      closeButtonProps={{
        onClick: () => {
          setIsOpen(false);
        },
      }}
      serviceButton={{
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          setIsOpen(false);
        },
        isMobile: true,
      }}
      onClose={() => {
        setIsOpen(false);
      }}
      disableOutsideClick
      onOpenChange={setIsOpen}
      open={isOpen}
      content={<AddMoneyRequisites account={account} />}
      size="fullscreen"
      height="fullscreen"
      isFullscreen
      modalProps={{ classNames: { wrapper: 'bg-transparent w-full' } }}
      contentClassName="h-max max-h-full bg-transparent"
    >
      {children}
    </DashboardDialog>
  );
};
